import axios from "axios";

import { RoutesPath } from "../../routes/RoutesPath";
import { API_ROUTES } from "./apiRoutes";
import { updatePermission } from "../../redux/slice/campaignSlice";
import {
  updateAdminDetails,
  updateClientBrands,
  updateReminderEmail,
} from "../../redux/slice/userSlice";
import { DOMAIN_NAME } from "../config";
import { setCookie } from "../cookies";
import { removeWhiteSpace } from "../DateAndFormat";

const sideBarContent = [
  {
    name: "Dashboard",
    navigation: RoutesPath.DASHBOARD,
    status: "Dashboard",
  },
  {
    name: "SMS Campaign",
    navigation: RoutesPath.CAMPAIGNHISTORY,
    status: "Sms Campaign",
  },
  { name: "List", navigation: RoutesPath.LIST, status: "List" },
  {
    name: "Contact",
    navigation: RoutesPath.CONTACT,
    status: "Contact",
  },
];

export const HandleUserApi = async (
  dispatch = () => null,
  navigation = () => null,
  token = "",
  formData
) => {
  let headers = token ? { Authorization: `Bearer ${token}` } : undefined;
  console.log(headers);
  try {
    const response = await axios.post(API_ROUTES.POST_ADMIN_LOGIN, formData, {
      headers,
    });
    const value = response?.data?.result;
    const userDetails = [value?.userAPIResult?.data || []].flat();
    let permission = value?.userPremissionAPIResult?.data || [];
    const client = value?.clientAPIResult?.data || null;
    const accessToken = value?.accessToken;
    console.log(userDetails);
    if (!userDetails?.length)
      return value?.accessToken || "Invalid Credentials";

    if (formData?.remember_me) dispatch(updateReminderEmail(formData?.email));
    const checkAdmin = userDetails?.[0]?.is_superadmin === 1;

    permission = permission.map((v) => {
      const findValue = removeWhiteSpace(v?.mainMenu)?.includes(
        removeWhiteSpace("Campaigns")
      );
      return {
        ...v,
        status: checkAdmin && findValue ? true : v?.status,
      };
    });
    const getSetterStatus = permission?.find((v) =>
      removeWhiteSpace(v?.mainMenu)?.includes(removeWhiteSpace("Campaigns"))
    );

    const checkPageAccess = getSetterStatus?.subMenus?.find((v) => v?.status);
    if (!getSetterStatus?.status) {
      window.open(DOMAIN_NAME?.layline, "_self");
    } else if (!checkPageAccess) {
      if (accessToken) setCookie(accessToken);
      dispatch(updatePermission(permission));
      dispatch(updateAdminDetails(userDetails));
      dispatch(updateClientBrands(client));

      navigation(RoutesPath.BLANK, { replace: true });
    } else {
      if (accessToken) setCookie(accessToken);
      dispatch(updatePermission(permission));
      dispatch(updateAdminDetails(userDetails));
      dispatch(updateClientBrands(client));

      const findStatus = sideBarContent?.find((v) =>
        removeWhiteSpace(checkPageAccess?.menu)?.includes(
          removeWhiteSpace(v?.status)
        )
      )?.navigation;
      const loc = window.location.pathname;
      const existingPath = getSetterStatus?.subMenus?.find(
        (s) =>
          s?.status &&
          removeWhiteSpace(loc)?.includes(removeWhiteSpace(s?.menu))
      );

      const path = existingPath ? loc || findStatus : findStatus;
      navigation(path, {
        replace: true,
        state: {
          token: accessToken || undefined,
          ...window?.history?.state?.usr,
        },
      });
    }
  } catch (error) {
    console.log(error);
    if (token) {
      navigation(RoutesPath.NEW_LOGIN, { replace: true });
    }
    return error?.response?.data?.message || "Network error";
  }
};
